export function setToBeginDay(date) {
  const beginOfDay = date.valueOf() - (date.valueOf() % 86400000)
  return new Date(beginOfDay)
}

export function monthlyViewDate(date, locale) {
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long'
  })
}

export function weeklyViewDate(startDate, endDate, locale) {
  return startDate.getMonth() === endDate.getMonth() 
    ? startDate.toLocaleDateString(locale, {
      day: '2-digit'
    }) + " - " + endDate.toLocaleDateString(locale, {
      day: '2-digit',
      year: 'numeric',
      month: 'long'
    })
    : startDate.toLocaleDateString(locale, {
      day: '2-digit',
      month: 'long'
    }) + " - " + endDate.toLocaleDateString(locale, {
      day: '2-digit',
      year: 'numeric',
      month: 'long'
    })
}

export function daylyViewDate(date, locale) {
  return date.toLocaleDateString(locale, {
    day: '2-digit',
    year: 'numeric',
    month: 'long'
  })
}